import axios, { AxiosError } from 'axios';
import { parseAxiosError } from '../common/constant';
import { BASEURL, LDAP_API_TOKEN } from './const';

/* HTTP Request Interceptor to add headers on all API calls */
axios.interceptors.request.use(
    config => {
        const token = sessionStorage.getItem('id');
        config.headers['x-api-key'] = token;
        config.headers['apikey'] = LDAP_API_TOKEN;
        return config;
    },
    error => {
        Promise.reject(error);
    }
)


/* HTTP Response Interceptor to redirect to not found page when 401 HTTP Code Received */
axios.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        return Promise.reject(error);
    }
)


/* to get the list of work packages types */
export const getWaymoreCrmTasks = async (signal?:AbortSignal): Promise<any> => {
    try {
        const response = await axios.get(`${BASEURL}/waymore-crm/tasks`,{signal});
        return response?.data;
    } catch (error: any) {
        return parseAxiosError(error as AxiosError);
    }
}